import React, { useState } from 'react';
import {
  useHistory,
  useParams,
  withRouter,
} from 'react-router-dom';

import {
  Container,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@material-ui/core';

import { Visibility, VisibilityOff } from '@material-ui/icons';

import { Formik } from 'formik';

import Alert from '@material-ui/lab/Alert';

import BasicButton from '../buttons/basicButton';
import SpinnerLoading from '../feedback/spinnerLoading';

import { resetPasswordVS } from '../../utils/formValidations';

import { resetPassword } from '../../utils/comms';

import translations from '../../languages/i18n';

import { resetPasswordForm } from '../../styles/formElementsStyles';

function ResetPassword() {
  const resetPasswordStyle = resetPasswordForm();

  const [passwordChanged, setPasswordChanged] = useState(false);
  const [severityMessage, setSeverityMessage] = useState('');
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [responseLogin, setResponseLogin] = useState('');

  const history = useHistory();
  const { passwordToken } = useParams();

  const gotoLogin = () => {
    history.push('/');
  };

  const handleResetPassword = async (data, resetForm) => {
    setShowLoading(true);
    const response = await resetPassword(data.username, data.newPassword, passwordToken);
    setShowLoading(false);
    if (response.status === 200) { // Contrasenya modificada
      resetForm(); // En mostrar la pantalla es mostrarà el formulari buit
      setShowConfirmPassword(false); // Ho tornam al valor inicial, per si l'usuari ho havia deixat en mode mostrar contrasenya
      setShowNewPassword(false); // Ho tornam al valor inicial, per si l'usuari ho havia deixat en mode mostrar contrasenya
      setPasswordChanged(true); // Mostram el botó per anar a Login
      setSeverityMessage('success');
      setResponseLogin(translations['_successChangePassword']);
    } else if (response === 'timeOut') { // El servidor no respon
      setSeverityMessage('error');
      setResponseLogin(translations['_errorTimeOut']);
    } else { // Resta d'errors
      setSeverityMessage('error');
      setResponseLogin(translations['_wrongOperation']);
    }
  };

  const onChangeNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const onChangeConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  // Per interrompre la 'bubble' i evitar que el navegador executi el seu comportament habitual davant d'aquest event
  const onMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Container component='main' maxWidth='xs'>
      <SpinnerLoading show={showLoading} />
      <div className={resetPasswordStyle.content}>
        <Formik
          initialValues={{ username: '', newPassword: '', confirmPassword: '' }}
          validationSchema={resetPasswordVS}
          onSubmit={(values, { resetForm }) => { handleResetPassword(values, resetForm); }}
        >
          {({ values, touched, errors, handleChange, handleBlur, submitForm }) => (
            <Grid container direction='row' spacing={2} alignItems='center' alignContent='center'>
              <Grid item xs={12}>
                <Grid container direction='column' spacing={3}>
                  <Grid item xs={12}>
                    <Grid container direction='column' spacing={1} alignItems='center' justify='center'>
                      <Grid item>
                        <img src={require('../../assets/images/logoHT.png')} alt='HT Logo' width='300' heigth='300' />
                      </Grid>
                      <Grid item>
                        <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center' }}>{translations['_newPassword1']}</Typography>
                        <Typography variant='body2' style={{ textAlign: 'center' }}>{translations['_newPassword2']}</Typography>
                        <Typography variant='body2' style={{ textAlign: 'center' }}>{translations['_newPassword3']}</Typography>
                        <Typography variant='body2' style={{ textAlign: 'center' }}>{translations['_newPassword4']}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <TextField
                      required
                      fullWidth
                      type='text'
                      variant='outlined'
                      id='username'
                      name='username'
                      label={translations['_username']}
                      error={Boolean(touched.username && errors.username)}
                      value={values.username}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.username && errors.username ? errors.username : ''}
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      required
                      fullWidth
                      type={showNewPassword ? 'text' : 'password'}
                      variant='outlined'
                      id='newPassword'
                      name='newPassword'
                      label={translations['_password']}
                      error={Boolean(touched.newPassword && errors.newPassword)}
                      value={values.newPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.newPassword && errors.newPassword ? errors.newPassword : ''}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton
                              onClick={onChangeNewPasswordVisibility}
                              onMouseDown={onMouseDownPassword}
                              edge='end'
                            >
                              {showNewPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      required
                      fullWidth
                      type={showConfirmPassword ? 'text' : 'password'}
                      variant='outlined'
                      id='confirmPassword'
                      name='confirmPassword'
                      label={translations['_confirmPassword']}
                      error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                      value={values.confirmPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.confirmPassword && errors.confirmPassword ? errors.confirmPassword : ''}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton
                              onClick={onChangeConfirmPasswordVisibility}
                              onMouseDown={onMouseDownPassword}
                              edge='end'
                            >
                              {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    {responseLogin ? <Alert severity={severityMessage}>{responseLogin}</Alert> : '' }
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container direction='row' spacing={2} justify='center'>
                      <Grid item>
                        {passwordChanged ? (
                          // El password s'ha canviat correctament, anam a la pantalla de login
                          <BasicButton handleClick={gotoLogin} type='accept' text={translations['_home']} />
                        ) : (
                          <BasicButton handleClick={submitForm} type='accept' text={translations['_newPasswordDialogTitle']}/>
                        )}
                      </Grid>
                      {/*<Grid item>
                        <BasicButton handleClick={gotoLogin} type='cancel' />
                      </Grid>*/}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Formik>
      </div>
    </Container>
  );
}

export default withRouter(ResetPassword);
